exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".EndOfGame-module__main__container__37h5M {\r\n    text-align: center;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.EndOfGame-module__end__text__24Rni {\r\n    color: red;\r\n    font-size: 30px;\r\n    margin-top: 20px;\r\n}", ""]);

// exports
exports.locals = {
	"main__container": "EndOfGame-module__main__container__37h5M",
	"end__text": "EndOfGame-module__end__text__24Rni"
};